exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ZyYIG{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ZyYIG:hover{opacity:.7}._1lLvo{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._1zlPj{z-index:10000;left:10px;overflow:scroll;width:400px;height:250px;border-radius:3px;background-color:rgba(0,0,0,.95)}._1zlPj,._1zlPj ._3H-fy{position:absolute;top:10px}._1zlPj ._3H-fy{right:5px;cursor:pointer;color:#fff}._1zlPj ._3H-fy:hover{opacity:.8}._1zlPj ._2-8wY{font-size:8px;line-height:8px;margin:5px;padding:5px;color:#fff}._1zlPj ._2-8wY ._3cQ9s{color:green}._1zlPj ._2-8wY ._3Gspq{color:#ff8c00}._1zlPj ._2-8wY ._13MwB{color:blue}._1zlPj ._2-8wY ._1D1q8{color:#f0f}._1zlPj ._2-8wY ._2iaJt{color:#fff}", ""]);

// exports
exports.locals = {
	"controlButton": "ZyYIG",
	"hidden": "_1lLvo",
	"debugPanel": "_1zlPj",
	"closeButton": "_3H-fy",
	"infoContainer": "_2-8wY",
	"string": "_3cQ9s",
	"number": "_3Gspq",
	"boolean": "_13MwB",
	"null": "_1D1q8",
	"key": "_2iaJt"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--10-1!../node_modules/postcss-loader/lib??ref--10-2!../node_modules/sass-loader/lib/loader.js??ref--10-3!../node_modules/playable/dist/src/modules/ui/debug-panel/debug-panel.scss
// module id = 94
// module chunks = 0